'use client';

import { useMediaQuery } from '@/hooks/useMediaQuery';
import * as authenticateAction from '@/redux/actions/authenticate';
import { baseURLImg, EXIST_LOCAL_STORAGE } from '@/services/constants/app';
import { getCookie, removeCookie } from '@/services/helperFunctions';
import { faBars, faBell, faChevronDown, faCircleXmark, faMagnifyingGlass, faMessage, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import { useOutsideClick } from 'outsideclick-react';
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FullTextSearchComponent from '../common/FullTextSearchComponent';
import Support from '../common/Support';
// import NotificationAndProfile from './navBarComponents/NotificationAndProfile';
import dynamic from 'next/dynamic';
import Skeleton from 'react-loading-skeleton';

const NotificationAndProfile = dynamic(() => import('./navBarComponents/NotificationAndProfile'), {
    ssr: false,
    loading: () => (
        <div className="d-flex gap-1 align-items-center">
            <Skeleton height={35} width={35} highlightColor="#6f91b7" baseColor="#3a5879" className="rounded-circle" />
            <Skeleton height={30} width={120} highlightColor="#6f91b7" baseColor="#3a5879" />
        </div>
    ),
});

interface NotificationList {
    title: string;
    read: any;
    active: any;
    content: any;
    page_id: any;
    page_type: any;
    page_referal: any;
    target_user_id: any;
    notification_id: any;
    getNotification?: any;
}

const menuItem = [
    {
        path: '/admin_panel/analytics',
        name: 'Analytics',
    },
    {
        path: '/admin_panel/post',
        name: 'Posts',
    },
    {
        path: '/admin_panel/post-moderation',
        name: 'Post Moderation',
    },
    {
        path: '/admin_panel/User',
        name: 'Users',
    },
    {
        path: '/admin_panel/user-roles',
        name: 'User Roles',
    },
    {
        path: '/admin_panel/portfolios',
        name: 'Portfolios',
    },
    {
        path: '/admin_panel/bonds',
        name: 'Bonds',
    },
    // {
    //   path: "/admin_panel/subscription",
    //   name: "Subscription",
    // },
    // {
    //   path: "/admin_panel/subscription-plan",
    //   name: "Subscription Plan",
    // },
    {
        path: '/admin_panel/positions',
        name: 'Positions',
    },
    {
        path: '/admin_panel/search-filter',
        name: 'Search Filters',
    },
];

const profileList = [
    {
        name: 'My Profile',
        path: '/myprofile/',
        // icon: PersonFill
    },
    {
        name: 'Followed Bonds',
        path: '/myprofile/bond-follow',
    },
    {
        name: 'Following Users',
        path: '/myprofile/user-followed',
    },
    {
        name: 'Followed Users',
        path: '/myprofile/user-following',
    },
];

const ScreenerNavbar = ({
    userLogOut,
    getAccessFeatures,
    profileImage = '',
    userDetailData,
    getNotification,
    notificationData,
    isnotificationDataLoader,
    NotificationRemove,
}: any) => {
    const router = useRouter();
    const pathname = usePathname();
    const [isToolsOpen, setIsToolsOpen] = useState(false);

    const [showFullTextForMobile, setShowFullTextForMobile] = useState<boolean>(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const handleOutsideClick = () => setShowFullTextForMobile(false);
    const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
    const UserId = getCookie(EXIST_LOCAL_STORAGE.USER_ID) || '';
    const isLoggedIn = !!UserId;
    const userImgHandle = getCookie(EXIST_LOCAL_STORAGE.USER_IMG) || '';
    const userName = getCookie(EXIST_LOCAL_STORAGE.USERNAME) || '';
    const userRole = getCookie(EXIST_LOCAL_STORAGE.ROLE) || '';
    const AuthToken = getCookie(EXIST_LOCAL_STORAGE.AUTHTOKEN) || '';
    const REFRESH_TOKEN = getCookie(EXIST_LOCAL_STORAGE.REFRESH_TOKEN) || '';

    const [openIndex, setOpenIndex] = useState(null);
    const [openIndexTools, setOpenIndexTools] = useState(null);
    const [openProfileIndex, setOpenProfileIndex] = useState(null);
    const ref = useOutsideClick(handleOutsideClick);

    const [notification, setNotification] = useState<NotificationList[]>([]);
    const [total_notifications, setTotalNotifications] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [showDropdown, setShowDropdown] = useState(false);

    const toggleFullTextForMobile = useCallback(() => setShowFullTextForMobile((prev) => !prev), []);

    const handleNotificationDropdownToggle = useCallback(() => {
        setShowNotificationDropdown(!showNotificationDropdown);
        console.log('Called handleNotificationDropdownToggle');
    }, [showNotificationDropdown]);

    const closeNotificationDropdown = useCallback(() => {
        console.log('Called closeNotificationDropdown');
        setShowNotificationDropdown(false);
    }, []);

    const handleDropdownToggle = useCallback(() => setShowDropdown((prev) => !prev), []);

    const handleToggleTools = useCallback((index: any) => setOpenIndexTools((prevIndex) => (prevIndex === index ? null : index)), []);

    const handleToggle = useCallback((index: any) => setOpenIndex((prevIndex) => (prevIndex === index ? null : index)), []);

    const handleProfileToggle = useCallback((index: any) => setOpenProfileIndex((prevIndex) => (prevIndex === index ? null : index)), []);

    const handleMenuItemClick = useCallback(() => setShowDropdown(false), []);

    const handleLogout = useCallback(async () => {
        const body = {
            accessToken: AuthToken,
            refreshToken: REFRESH_TOKEN,
        };

        localStorage.clear();
        removeCookie();
        router.push('/');
        userLogOut(body);
    }, [AuthToken, REFRESH_TOKEN, userLogOut, removeCookie]);

    const handleMenuOpen = () => setIsMenuOpen(!isMenuOpen);

    const handleToolsMouseEnter = () => setIsToolsOpen(true);

    const handleToolsMouseLeave = () => setIsToolsOpen(false);

    const isActiveLink = useCallback((path: string, name: string) => pathname === path, [pathname]);

    // let isCancelled = false;
    const fetchNotificationData = useCallback(async () => {
        if (UserId) {
            try {
                let body = {
                    params: {
                        user_id: UserId,
                        page_no: currentPage,
                    },
                };
                getNotification(body).then((response: any) => {
                    if (response?.code === 200) {
                        const newData = response?.data[0];
                        const newNotificationList = response?.status === 'Error' ? [] : newData?.notificationList;
                        setTotalNotifications(newData?.total_records);
                        if (newData?.page_no === 1) {
                            setNotification(newNotificationList);
                        } else {
                            setNotification((prevData) => [...prevData, ...newNotificationList]);
                        }
                    }
                    setHasMore(
                        response?.code !== 200 ? false : (response.data?.[0]?.total_records - response.data?.[0].end_record || 0) > 0
                    );
                });
            } catch (error: any) {
                console.error(' :', error);
            }
        }
    }, [getNotification, handleLogout, currentPage, UserId]);

    const fetchNotificationAfterRemove = useCallback(() => {
        if (UserId) {
            try {
                const body = {
                    params: {
                        user_id: UserId,
                        page_no: 1,
                    },
                };
                getNotification(body).then(async (response: any) => {
                    const newData = response?.status === 'Error' ? [] : response?.data[0]?.notificationList;
                    setTotalNotifications(response?.data[0]?.total_records);
                    setNotification(newData);
                    setHasMore(response?.code !== 200 ? false : response.data[0].total_records - response.data[0].end_record > 0);
                });
                setCurrentPage(1);
            } catch (error: any) {
                console.error(' :', error);
            }
        }
    }, [getNotification, router, UserId]);

    const removeNotifications = useCallback(
        async (id: any, type: any) => {
            if (type === 'All') setTotalNotifications(0);

            const unreadNotifications = type === 'All' ? notification.filter((notification: any) => !notification.read) : [];
            const unreadNotificationsIds = unreadNotifications.map((notification: any) => notification.notification_id);
            const body = {
                notfication_id: type === 'content' ? [id] : unreadNotificationsIds,
            };
            const params = {
                user_id: UserId,
            };
            if (type !== 'content') {
                setNotification([]);
                // setTotalNotifications('0');
            }
            await NotificationRemove(body, params);
            notification.length <= 20 && hasMore && fetchNotificationAfterRemove();
            setNotification((prevData) => [...prevData.filter((notification) => notification.notification_id !== id)]);
        },
        [notification, UserId, fetchNotificationAfterRemove, hasMore, NotificationRemove]
    );

    const fetchMoreData = () => {
        setCurrentPage((prevPage) => prevPage + 1);
    };

    const handleNavigateToLink = (link: string) => {
        if (link !== '') {
            router.push(link);
            // setShowNotificationDropdown(false);
        }
    };
    useEffect(() => {
        if (isLoggedIn && ((showNotificationDropdown && notification.length > 0) || total_notifications === 0)) {
            fetchNotificationData();
        }
    }, [showNotificationDropdown, isLoggedIn, currentPage]);

    useEffect(() => {
        if (notificationData) {
            const notificationDataFromRedux = notificationData.data?.[0] || {};
            if (Array.isArray(notificationDataFromRedux.notificationList) && notificationDataFromRedux.page_no === 1) {
                setCurrentPage(1);
                setNotification(notificationDataFromRedux.notificationList);
                setTotalNotifications(notificationDataFromRedux.total_records);
                setHasMore(notificationDataFromRedux.total_records - notificationDataFromRedux.end_record > 0);
            }
        }
    }, [notificationData]);

    // Tools menus for mobile responsive
    const Tools = useMemo(
        () => [
            {
                title: 'Tools',
                content: (
                    <Nav
                        style={{
                            width: '200px',
                            borderStyle: 'none',
                            backgroundColor: 'transparent',
                        }}
                    >
                        <Link
                            href="/screener"
                            className={`text-nowrap nav-link rounded ${isActiveLink('/screener', 'Bond Screener') ? 'active' : ''}`}
                            onClick={handleMenuOpen}
                        >
                            Bond Screener
                        </Link>
                        <Link
                            href="/issuers/a"
                            className={`text-nowrap nav-link rounded ${isActiveLink('/issuers/a', '/issuers/a') ? 'active' : ''}`}
                            onClick={handleMenuOpen}
                        >
                            Issuer Directory
                        </Link>
                        <Link
                            href={'/portfolio'}
                            className={`text-nowrap nav-link rounded ${isActiveLink('/portfolio', 'Portfolio Builder') ? 'active' : ''}`}
                            onClick={handleMenuOpen}
                        >
                            Portfolio Builder
                        </Link>

                        <Link
                            href={'/discussion'}
                            className={`text-nowrap nav-link rounded ${isActiveLink('/discussion', 'Discussion Board') ? 'active' : ''}`}
                            onClick={handleMenuOpen}
                        >
                            Discussion Board
                        </Link>
                    </Nav>
                ),
            },
        ],
        [pathname, handleMenuOpen]
    );

    // admin panel menus for mobile responsive
    const sections = useMemo(
        () => [
            {
                title: 'Admin',
                content: (
                    <Nav
                        className="flex-column"
                        style={{
                            width: '200px',
                            borderStyle: 'none',
                            backgroundColor: 'transparent',
                        }}
                    >
                        {menuItem.map((item, index) => (
                            <Link
                                href={item.path}
                                key={index}
                                onClick={handleMenuOpen}
                                className={`text-nowrap nav-link rounded ${pathname !== item.path ? 'active-admin' : ''}`}
                            >
                                {item.name}
                            </Link>
                        ))}
                    </Nav>
                ),
            },
        ],
        [pathname, handleMenuOpen]
    );

    //profile menus for mobile responsive
    const profile = useMemo(
        () => [
            {
                title: 'My Profile',
                content: (
                    <Nav
                        style={{
                            width: '200px',
                            borderStyle: 'none',
                            backgroundColor: 'transparent',
                        }}
                    >
                        {profileList.map((item, index) => (
                            <Link
                                href={item.path}
                                key={index}
                                onClick={handleMenuOpen}
                                className={`text-nowrap nav-link rounded ${pathname !== item.path ? 'active-admin' : ''}`}
                            >
                                {item.name}
                            </Link>
                        ))}
                    </Nav>
                ),
            },
        ],
        [pathname]
    );

    const isMobile = useMediaQuery('(max-width: 991px)'); // lg

    //desktop menu layout
    const DesktopView = useMemo(
        () =>
            isMobile ? null : (
                <ul className={`shibui-navbar navbar-nav  shibuiv3-navbar mb-2 mb-lg-0 text-nowrap`}>
                    <li className="nav-item py-0">
                        <Link
                            href={`/${isLoggedIn ? 'dashboard' : 'login?redirectTo=dashboard'}`}
                            prefetch
                            className={`nav-link mb-logout-search hover-shibui-nav-link rounded cursor-pointer ${
                                isActiveLink('/dashboard', 'dashboard') ? 'active' : ''
                            }`}
                            style={{ margin: '2px 0' }}
                        >
                            My Dashboard
                        </Link>
                    </li>
                    <li className="nav-item py-0">
                        <Link
                            href="/bond-academy"
                            prefetch
                            className={`nav-link mb-logout-search hover-shibui-nav-link rounded cursor-pointer ${
                                isActiveLink('/bond-academy', 'Bond Academy') ? 'active' : ''
                            }`}
                            style={{ margin: '2px 0' }}
                        >
                            Bond Academy
                        </Link>
                    </li>
                    <li
                        className="nav-item py-0 shibui-dropdown"
                        onMouseEnter={handleToolsMouseEnter}
                        onMouseLeave={handleToolsMouseLeave}
                        onClick={handleToolsMouseLeave}
                    >
                        <span onClick={(e) => e.stopPropagation()} className="nav-link" style={{ cursor: 'default' }}>
                            Tools
                            <FontAwesomeIcon
                                icon={faChevronDown}
                                className={`ms-1 transition-icon ${isToolsOpen ? 'rotate-icon' : ''}`}
                                size="xs"
                            />
                        </span>
                        <ul className={`dropdown-menu ${isToolsOpen ? 'show' : ''}`} aria-labelledby="toolsDropdown">
                            <li>
                                <Link
                                    href="/screener"
                                    prefetch
                                    className={`dropdown-item ${isActiveLink('/screener', 'Bond Screener') ? 'active' : ''}`}
                                >
                                    Bond Screener
                                </Link>
                            </li>
                            <li>
                                <Link
                                    href="/issuers/a"
                                    prefetch
                                    className={`dropdown-item ${isActiveLink('/issuers/a', 'Issuer Directory') ? 'active' : ''}`}
                                >
                                    Issuer Directory
                                </Link>
                            </li>
                            <li>
                                <Link
                                    href={`/${isLoggedIn ? 'portfolio' : 'login?redirectTo=portfolio'}`}
                                    prefetch
                                    className={`dropdown-item ${isActiveLink('/portfolio', 'Portfolio Builder') ? 'active' : ''}`}
                                >
                                    Portfolio Builder
                                </Link>
                            </li>
                            <li>
                                <Link
                                    href={`/${isLoggedIn ? 'discussion' : 'login?redirectTo=discussion'}`}
                                    prefetch
                                    className={`dropdown-item ${isActiveLink('/discussion', 'Discussion Board') ? 'active' : ''}`}
                                >
                                    Discussion Board
                                </Link>
                            </li>
                            {['Administrator', 'Developer', 'Moderator'].includes(userRole) && (
                                <>
                                    <li>
                                        <div className="dropdown-divider"></div>
                                    </li>
                                    <li>
                                        <Link
                                            href="/admin_panel/analytics"
                                            prefetch
                                            className={`dropdown-item ${
                                                isActiveLink('/admin_panel/analytics', 'Admin Panel') ? 'active' : ''
                                            }`}
                                        >
                                            Admin Panel
                                        </Link>
                                    </li>
                                </>
                            )}
                        </ul>
                    </li>
                    <li className="nav-item py-0">
                        <Link
                            href="/partners"
                            prefetch
                            className={`nav-link mb-logout-search hover-shibui-nav-link rounded cursor-pointer ${
                                isActiveLink('/partners', 'Data Partners') ? 'active' : ''
                            }`}
                            style={{ margin: '2px 0' }}
                        >
                            Data Partners
                        </Link>
                    </li>
                </ul>
            ),
        [isActiveLink, isToolsOpen, handleToolsMouseEnter, handleToolsMouseLeave, userRole, isLoggedIn, isMobile]
    );

    const MobileView = useMemo(
        () => (
            // !isMobile ? null : (
            <>
                <ul className="shibui-navbar navbar-nav  mb-2 mb-lg-0">
                    <li className="nav-item" style={{ paddingBottom: '8px', paddingTop: '8px' }}>
                        <Link
                            href={'/'}
                            prefetch
                            className={`nav-link mb-logout-search rounded  ${isActiveLink('/', '') ? 'active' : ''}`}
                            onClick={handleMenuOpen}
                        >
                            Home
                        </Link>
                    </li>
                    <li className="nav-item" style={{ paddingBottom: '8px', paddingTop: '8px' }}>
                        <Link
                            href={`/${isLoggedIn ? 'dashboard' : 'login?redirectTo=dashboard'}`}
                            prefetch
                            className={`nav-link mb-logout-search rounded  ${isActiveLink('/dashboard', 'dashboard') ? 'active' : ''}`}
                            onClick={handleMenuOpen}
                        >
                            My Dashboard
                        </Link>
                    </li>
                    <li className="nav-item" style={{ paddingBottom: '8px', paddingTop: '8px' }}>
                        <Link
                            href="/bond-academy"
                            prefetch
                            className={`nav-link mb-logout-search rounded  ${
                                isActiveLink('/bond-academy', 'Bond Academy') ? 'active' : ''
                            }`}
                            onClick={handleMenuOpen}
                        >
                            Bond Academy
                        </Link>
                    </li>
                    <li className="nav-item" onMouseEnter={handleToolsMouseEnter} onMouseLeave={handleToolsMouseLeave}>
                        {Tools.map((section, index) => (
                            <div className="accordion-item-cus1" key={index}>
                                <div className="accordion-header-cus title-interview-docs pb-0" onClick={() => handleToggleTools(index)}>
                                    <span style={{ fontSize: '16px' }}>{section.title}</span>
                                    <span className={`icon-accordion-cus ${openIndexTools === index ? 'open' : ''}`} />
                                </div>
                                {openIndexTools === index && <div className="accordion-content-cus">{section.content}</div>}
                            </div>
                        ))}
                    </li>
                    {(userRole === 'Administrator' || userRole === 'Developer') && (
                        <li className="nav-item">
                            <>
                                {sections.map((section, index) => (
                                    <div className="accordion-item-cus1" key={index}>
                                        <div
                                            className="accordion-header-cus title-interview-docs"
                                            onClick={() => handleToggle(index)}
                                            style={{ paddingBottom: '0px' }}
                                        >
                                            <span style={{ fontSize: '16px' }}>{section.title}</span>
                                            <span className={`icon-accordion-cus ${openIndex === index ? 'open' : ''}`} />
                                        </div>
                                        {openIndex === index && <div className="accordion-content-cus">{section.content}</div>}
                                    </div>
                                ))}
                            </>
                        </li>
                    )}
                    <li className="nav-item" style={{ paddingBottom: '8px', paddingTop: '8px' }}>
                        <Link
                            href="/partners"
                            prefetch
                            className={`nav-link mb-logout-search rounded  ${isActiveLink('/partners', 'Data Partners') ? 'active' : ''}`}
                            onClick={handleMenuOpen}
                        >
                            Data Partners
                        </Link>
                    </li>
                </ul>

                {isLoggedIn ? (
                    <ul className="shibui-navbar navbar-nav mb-2 mb-lg-0" style={{ marginTop: '-25px' }}>
                        <li className="nav-item ">
                            <div className="">
                                {profile.map((section, index) => (
                                    <div
                                        className="accordion-item-cus1 flex-column"
                                        key={index}
                                        style={{ paddingBottom: '13px', paddingTop: '13px' }}
                                    >
                                        <div
                                            className="accordion-header-cus title-interview-docs"
                                            style={{ paddingBottom: '0px' }}
                                            onClick={() => handleProfileToggle(index)}
                                        >
                                            <span style={{ fontSize: '16px' }}>{section.title}</span>
                                            <span className={`icon-accordion-cus ${openProfileIndex === index ? 'open' : ''}`} />
                                        </div>
                                        {openProfileIndex === index && <div className="accordion-content-cus">{section.content}</div>}
                                    </div>
                                ))}
                            </div>
                            <ul className="shibui-navbar navbar-nav mb-2 mb-lg-0">
                                <li className="nav-item ">
                                    <Nav
                                        onClick={handleLogout}
                                        className="nav-link bg-transparent mb-logout-search"
                                        style={{ width: '100%', paddingTop: '14px' }}
                                    >
                                        Logout
                                    </Nav>
                                </li>
                            </ul>
                        </li>
                        {/* <li className="nav-item">
                    </li> */}
                    </ul>
                ) : (
                    <ul className=" navbar-nav  my-2 mb-lg-0">
                        <li className="d-flex flex-column" style={{ paddingBottom: '10px', paddingTop: '10px' }}>
                            <Link
                                href="/login"
                                prefetch
                                className="mb-logout-search bg-white text-black login-button rounded fw-bolder"
                                style={{ color: '#333333!important' }}
                            >
                                Login
                            </Link>
                            <Link
                                href="/registerpage"
                                prefetch
                                className="mb-logout-search text-white my-4 rounded fw-bolder"
                                style={{ backgroundColor: '#198754' }}
                            >
                                Create a free account
                            </Link>
                        </li>
                    </ul>
                )}
            </>
        ),
        [pathname, openIndex, openProfileIndex, profile, sections, handleLogout, handleMenuOpen, handleProfileToggle, isMobile]
    );

    return (
        <div className={'shibui-navbar-container'}>
            {!isMobile ? (
                <Navbar expand="lg" className=" navbar-dark bg-shibuiv3-navbar d-lg-block d-none  fixed-top">
                    <Container fluid className="px-3">
                        <div className="col-lg-1 col-md-12">
                            <div className="d-flex justify-content-between">
                                <div>
                                    <Link href="/" className="navbar-brand d-inline-block">
                                        <Image
                                            src="/img/whitelogo.png"
                                            loading="eager"
                                            alt="SQXlogo"
                                            className=" cursor-pointer"
                                            width={130}
                                            height={30}
                                            unoptimized
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-11">
                            <Navbar.Collapse
                                id="basic-navbar-nav"
                                className="shibui-navbar navbar-nav d-flex justify-content-between px-lg-5  mb-2 mb-lg-0"
                            >
                                <FullTextSearchComponent isMobile={false} closeFulltextForMobile={() => setShowFullTextForMobile(false)} />

                                {DesktopView}

                                <NotificationAndProfile
                                    userName={userName}
                                    isLoggedIn={isLoggedIn}
                                    closeNotificationDropdown={closeNotificationDropdown}
                                    fetchMoreData={fetchMoreData}
                                    handleDropdownToggle={handleDropdownToggle}
                                    handleLogout={handleLogout}
                                    handleMenuItemClick={handleMenuItemClick}
                                    handleNavigateToLink={handleNavigateToLink}
                                    handleNotificationDropdownToggle={handleNotificationDropdownToggle}
                                    hasMore={hasMore}
                                    isnotificationDataLoader={isnotificationDataLoader}
                                    notification={notification}
                                    profileImage={profileImage}
                                    removeNotifications={removeNotifications}
                                    showDropdown={showDropdown}
                                    showNotificationDropdown={showNotificationDropdown}
                                    total_notifications={total_notifications}
                                    userImgHandle={userImgHandle}
                                />
                            </Navbar.Collapse>
                        </div>
                    </Container>
                </Navbar>
            ) : (
                <Navbar expand="lg" className=" navbar-dark bg-shibui-navbar d-lg-none d-block fixed-top ">
                    <Container className="d-flex justify-content-between container-fluid mx-2" style={{ maxWidth: '100%' }}>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleMenuOpen}>
                            <FontAwesomeIcon icon={faBars} />
                        </Navbar.Toggle>
                        <Link href="/" className="navbar-brand ms-2">
                            <Image
                                src="/img/whitelogo.png"
                                loading="eager"
                                alt="SQXlogo"
                                className=" cursor-pointer"
                                width={130}
                                height={30}
                            />
                        </Link>
                        <div className="ms-auto" ref={ref}>
                            {showFullTextForMobile && (
                                <div
                                    className={`col-12 position-absolute row justify-content-center p-0 m-0 `}
                                    style={{ top: '93%', left: 0 }}
                                >
                                    <FullTextSearchComponent
                                        isMobile={true}
                                        closeFulltextForMobile={handleOutsideClick}
                                        toggleFullTextForMobile={toggleFullTextForMobile}
                                    />
                                </div>
                            )}
                            <span className={`ms-auto me-3 p-2 ${showFullTextForMobile ? 'border-bottom border-2 border-secondary' : ''} `}>
                                <FontAwesomeIcon icon={faMagnifyingGlass} color="#fff" size="xl" onClick={toggleFullTextForMobile} />
                            </span>
                        </div>

                        {isLoggedIn && (
                            <Dropdown
                                id="navbarDropdown"
                                className="notification-dropdown-mobile px-0 mx-0"
                                show={showNotificationDropdown}
                                onToggle={handleNotificationDropdownToggle}
                            >
                                <Dropdown.Toggle variant="Secondary" size="sm" className="px-0 mx-0 me-2">
                                    <span className="notification-icon ">
                                        {
                                            <div className="position-relative mt-2">
                                                <FontAwesomeIcon icon={faBell} color="#fff" size="xl" />
                                                {!!total_notifications && (
                                                    <span
                                                        className="position-absolute top-0 start-100 translate-middle bg-success  rounded-circle"
                                                        style={{
                                                            fontSize: '9px',
                                                            width: '20px',
                                                            height: '20px',
                                                            padding: '3px 3px',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        {total_notifications}
                                                        {/* <span className="visually-hidden">4</span> */}
                                                    </span>
                                                )}
                                            </div>
                                        }
                                    </span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu
                                    style={{ width: '300px' }}
                                    className="notification-menu left-200"
                                    aria-labelledby="navbarDropdown"
                                >
                                    <h5 className="notification-head d-flex justify-content-end align-items-center">
                                        Notifications
                                        <div className="flex-grow-1 text-end">
                                            {' '}
                                            {notification.length > 0 && (
                                                <span
                                                    className="cursor-pointer rounded py-1 px-2 me-2 text-center bg-shibui-navbar text-white "
                                                    onClick={() => {
                                                        removeNotifications(0, 'All');
                                                    }}
                                                >
                                                    Clear All
                                                </span>
                                            )}
                                        </div>
                                        <span className="notification-head-close ps-0 pe-1 m-auto">
                                            <FontAwesomeIcon
                                                icon={faXmark}
                                                size="lg"
                                                className="cursor-pointer p-1"
                                                onClick={closeNotificationDropdown}
                                            />
                                        </span>
                                    </h5>
                                    <InfiniteScroll
                                        dataLength={notification?.length ? notification.length : 0}
                                        next={fetchMoreData}
                                        hasMore={hasMore}
                                        height={170}
                                        loader={
                                            !isnotificationDataLoader ? (
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                                    <div className="lazy-notification-container">
                                                        <div className="stripe lazy-notification-title"></div>
                                                        <div className="stripe lazy-notification-desc"></div>
                                                        <div className="stripe lazy-notification-desc"></div>
                                                    </div>
                                                    <div className="lazy-notification-container">
                                                        <div className="stripe lazy-notification-title"></div>
                                                        <div className="stripe lazy-notification-desc"></div>
                                                        <div className="stripe lazy-notification-desc"></div>
                                                    </div>
                                                </div>
                                            ) : (
                                                ''
                                            )
                                        }
                                        scrollableTarget="scrollableDiv"
                                    >
                                        <div className="notification-body_content pt-2">
                                            {notification.length === 0 ? (
                                                <tr>
                                                    <td colSpan={4} className="text-center">
                                                        <h5 className="text-center text-muted fst-italic px-4 mt-3">
                                                            No Notification Found...!
                                                        </h5>
                                                    </td>
                                                </tr>
                                            ) : (
                                                notification?.map((item: any, index) => {
                                                    return (
                                                        <div className="drop-down-item-notification px-2" key={index}>
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <div
                                                                    className="rounded p-1 cursor-pointer"
                                                                    onClick={() => handleNavigateToLink(item?.page_referal)}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={faMessage}
                                                                        color="#AAAAAA"
                                                                        style={{ paddingTop: '2px' }}
                                                                    />
                                                                    <span
                                                                        style={{ fontWeight: '700', marginLeft: '4px' }}
                                                                        key={item?.notification_id}
                                                                    >
                                                                        {item?.title}
                                                                    </span>
                                                                    <div
                                                                        style={{
                                                                            marginLeft: '16px',
                                                                            wordWrap: 'break-word',
                                                                            wordBreak: 'break-all',
                                                                        }}
                                                                        className="notification-break-text-style"
                                                                    >
                                                                        <span className="text-muted">{item?.content}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="float-end" style={{ marginTop: '-10px' }}>
                                                                    <FontAwesomeIcon
                                                                        icon={faCircleXmark}
                                                                        color="red"
                                                                        className="cursor-pointer"
                                                                        onClick={() => {
                                                                            removeNotifications(item?.notification_id, 'content');
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            )}
                                        </div>
                                    </InfiniteScroll>
                                </Dropdown.Menu>
                            </Dropdown>
                        )}
                        {isLoggedIn ? (
                            <div className="d-flex align-items-center">
                                <div className="mx-2">
                                    <Image
                                        loading="lazy"
                                        src={
                                            profileImage !== ''
                                                ? profileImage
                                                : userImgHandle !== ''
                                                  ? baseURLImg + 'Images/' + userImgHandle
                                                  : '/assets/images/avatar.jpg'
                                        }
                                        className="avatar rounded-circle nav-avatar"
                                        alt="Avatar"
                                        width={32}
                                        height={32}
                                        style={{ objectFit: 'cover' }}
                                        unoptimized
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className="">
                                <Nav className=""></Nav>
                            </div>
                        )}
                    </Container>
                </Navbar>
            )}

            {/* <Modal show={!!showModal} onHide={() => setShowModal(null)} className="custom-modal">
                <Modal.Header closeButton>
                    <Modal.Title className="custom-modal-title">Login Required</Modal.Title>
                </Modal.Header>
                <Modal.Body className="custom-modal-body">
                    <p>Login or register with a free account to access all SQXBonds trading tools!</p>
                </Modal.Body>
                <Modal.Footer className="custom-modal-footer">
                    <Button variant="secondary" onClick={() => setShowModal(null)} className="custom-button-secondary">
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => router.push(`/login?redirectTo=${showModal}`)}
                        className="custom-button-primary"
                    >
                        Login
                    </Button>
                </Modal.Footer>
            </Modal> */}

            <div id="sidebar" className={`offcanvas offcanvas-start ${isMenuOpen ? 'show' : ''}`} style={{ maxWidth: '250px' }}>
                <div className="offcanvas-header" style={{ backgroundColor: '#112c52' }}>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        style={{ backgroundColor: '#fff' }}
                        onClick={handleMenuOpen}
                    ></button>
                </div>
                <div className="offcanvas-body" style={{ backgroundColor: '#112c52' }}>
                    {/* <NavBarMenu handleMenuOpen={handleMenuOpen} /> */}
                    {MobileView}
                    {/* {isLoggedIn ? (
                        <div className="row mt-3" style={{ justifyContent: 'center' }}>
                            <div className="nav-item ms-2">
                                <a href="#" className="subscription-badge">
                    <span className="badge rounded-pill bg-warning text-dark">
                      Upgrade
                    </span>
                  </a>
                            </div>
                        </div>
                    ) : (
                        <div></div>
                    )} */}
                </div>
            </div>

            {isLoggedIn && <Support />}
        </div>
    );
};
const mapStatesToProps = ({
    authenticate: { isLogOutLoader = false, notificationData = [], isnotificationDataLoader = false },
    users: { profileImage = '', userDetailData = {} },
    accessFeatures: { accessFeatureData = [], isaccessFeatureLoader = false },
}: any) => {
    return {
        isLogOutLoader,
        notificationData,
        isnotificationDataLoader,
        profileImage,
        userDetailData,
        accessFeatureData,
        isaccessFeatureLoader,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators(
        {
            ...authenticateAction,
            // ...userAction,
            // ...accessFeature
        },
        dispatch
    );
};

export default connect(mapStatesToProps, mapDispatchToProps)(memo(ScreenerNavbar));
